import "./SectionFive.css";

import React from "react";

import { useEffect, useState } from "react";

import { SectionFiveSlider } from "./SectionFiveSlider";

export const SectionFive = () => {
  const [sectionFiveSliderContent, setSectionFiveSliderContent] = useState([]);
  useEffect(() => {
    setSectionFiveSliderContent([
      {
        name: "Марио Топузов",
        position: "ФК ЦСКА-1948",
        text: "Доволен съм,обувките са много удобни и здрави,цената си заслужава.",
      },
      {
        name: "Алекс Колев",
        position: "ФК ЦСКА-1948",
        text: "Препоръчвам на всички спортисти продуктите на New Football Boots ! Коректно отношение,качество на топ ниво и бърза отзивчивост.",
      },
      {
        name: "Мохамед Брахими",
        position: "ПФК Ботев Пловдив",
        text: "Благодаря за обувките, страхотни са.Не сбърках като послушах съвета които ми дадохте, а също така доставката беше бърза.Честно казано вие сте върха.",
      },
      {
        name: "Матиас Куриор",
        position: "ПФК Черно Море",
        text: "Доверявам се изцяло на New Football Boots ,защото тяхното удобство е незаменимо.",
      },
      {
        name: "Каули Оливейра Соуза",
        position: "ПФК Лудогорец 1945",
        text: "Използвам обувките на New Football Boots от 3 години и нямам никакви оплаквания.Те са най-добрите в България.",
      },
    ]);
  }, []);

  return (
    <div className="section-five-container">
      <h1 className="section-five-text2">Отзиви</h1>

      <SectionFiveSlider sectionFiveSliderContent={sectionFiveSliderContent} />
    </div>
  );
};
